<div class="confirm-main">
    <h1 mat-dialog-title
        class="draggable-dialogue-header"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        {{Title}}
    </h1>

    <div *ngIf="IsDeleteAction">
        Are you sure you wish to proceed?
        <mat-checkbox [(ngModel)]="actOnAllAttachments" matTooltip="Delete all versions of this attachment">Delete all Versions of this Attachment</mat-checkbox>
    </div>

    <div *ngIf="IsRestoreAction">
        Are you sure you wish to proceed?
        <mat-checkbox [(ngModel)]="actOnAllAttachments" matTooltip="Restore all versions of this attachment">Renable all versions of this Attachment</mat-checkbox>
    </div>

    <div mat-dialog-actions class="confirm-buttons">
        <button mat-raised-button color="primary" class="theme-primary-btn" (click)="onConfirm()">OK</button>
        <button mat-button (click)="onCancel()">Cancel</button>
    </div>
</div>
